<template>
<!-- 升级任务与配置任务组件 -->
  <div>
    <el-dialog :title="title" :visible.sync="centerDialogVisible" width="60%" center
    append-to-body>
      <!-- <div class="dialog-con">
        <span class="tetxp">{{$t('lang.taskDialog.TaskStatus')}}：</span>
        <el-input size="mini" class="adduserinput" v-model="addtaskms"
        :placeholder="$t('lang.taskDialog.reassign_task_to')"></el-input>
      </div> -->
      <div style="text-align:center">
      <div class="Left_Con">
        <div class="dialog-con">
        <span class="tetxp">{{$t('lang.taskDialog.FutureTask')}}：</span>
        <el-input size="mini" class="adduserinput" v-model="addtaskname"
        :placeholder="$t('lang.taskDialog.provide')"></el-input>
      </div>
      <div class="dialog-con" v-if="title==$t('lang.upgrade.addDistributionPackages')">
        <span class="tetxp">{{$t('lang.upgrade.file')}}：</span>
        <el-select v-model="pack" :placeholder="$t('lang.taskDialog.please')" class="adduserinput" size="mini"
        @change="getpack">
          <el-option
            v-for="item in packlist"
            :key="item.spId"
            :label="item.spName"
            :value="item.spId"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-con" v-if="title==$t('lang.upgrade.addDistributionPackages')">
        <span class="tetxp">文件服务器：</span>
        <el-select v-model="FirmwareValue" :placeholder="$t('lang.taskDialog.please')" class="adduserinput" size="mini">
          <el-option
        v-for="item in FirmwareList"
        :key="item.value"
        :label="item.label"
        :value="item.value">
        </el-option>
        </el-select>
      </div>
      <div class="dialog-con" v-if="title==$t('lang.firmware.configuration')">
        <span class="tetxp">{{$t('lang.upgrade.file')}}：</span>
        <el-select v-model="pack" :placeholder="$t('lang.taskDialog.please')" class="adduserinput" size="mini"
        @change="getpackpz">
          <el-option
            v-for="item in packlist"
            :key="item.cfId"
            :label="item.cfName"
            :value="item.cfId"
          ></el-option>
        </el-select>
      </div>
      </div>
      <div class="Right_Con">
      <div class="dialog-con">
        <span class="tetxp">{{$t('lang.taskDialog.group1')}}：</span>
        <el-select v-model="Grouping1" :placeholder="$t('lang.taskDialog.please')" class="adduserinput"
        filterable size="mini"
        @change="getGroupList2">
          <el-option
            v-for="item in Grouplist"
            :key="item.group_id"
            :label="item.group_name"
            :value="item.group_id"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-con">
        <span class="tetxp">{{$t('lang.taskDialog.group2')}}：</span>
        <el-select v-model="Grouping2" :placeholder="$t('lang.taskDialog.please')" class="adduserinput"
        filterable size="mini"
        @change="getGroupList3">
          <el-option
            v-for="item in Groupinglist2"
            :key="item.group_id"
            :label="item.group_name"
            :value="item.group_id"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-con">
        <span class="tetxp">{{$t('lang.taskDialog.group3')}}：</span>
        <el-select v-model="Grouping3" :placeholder="$t('lang.taskDialog.please')" class="adduserinput"
        filterable size="mini" @change="getGroupList3devices">
          <el-option
            v-for="item in Groupinglist3"
            :key="item.group_id"
            :label="item.group_name"
            :value="item.group_id"
          ></el-option>
        </el-select>
      </div>
      </div>
      </div>
      <!-- <div class="dialog-con">
        <span class="tetxp">{{$t('lang.taskDialog.Equipment')}}：</span>
        <el-select
        v-model="deviceDid"
        multiple
        collapse-tags
        :placeholder="$t('lang.taskDialog.please')" class="adduserinput" size="mini">
        <el-option
        v-for="item in deviceslist"
        :key="item.deviceDid"
        :label="item.deviceSn"
        :value="item.deviceDid">
        </el-option>
      </el-select>
      </div> -->
      <div v-if="this.uppack&&title==$t('lang.upgrade.addDistributionPackages')">
        <!-- <div class="dialog-con">
          <span class="packTitle">适用产品：</span>
          <span class="packText">111</span>
        </div> -->
        <div style="text-align:center">
        <div class="dialog-con">
          <span class="packTitle">文件大小：</span>
          <span class="packText">{{this.uppack.spFileSize/1024/1024}}M</span>
        </div>
        <div class="dialog-con">
          <span class="packTitle">MD5：</span>
          <span class="packText">{{this.uppack.spMd5}}</span>
        </div>
        </div>
      </div>
      <div class="Bottom_Con">
        <slot></slot>
      <div class="box-con">
        <el-card class="box-card">
          <div class="box-card--tree">
            <p class="box-card--title">设备待选列表</p>
            <el-input
            placeholder="输入序列号进行过滤"
            size="mini"
            v-model="filterValue">
            </el-input>
            <el-tree
            node-key="deviceId"
            :props="DeviceProps"
            :data="deviceslist"
            :filter-node-method="filterNode"
            @check="handleCheckChange"
            ref="UpGradeTree"
            show-checkbox>
            </el-tree>
          </div>
        </el-card>
        <el-card class="box-card">
          <div class="box-card--tree">
            <p class="box-card--title">设备选中列表(<span class="SelectedColor">{{deviceDidList.length}}</span>)
            <span class="SelectedColor" @click="Textarea=!Textarea">{{!Textarea?'编辑':'确定'}}</span></p>
            <el-tree
            node-key="deviceId"
            :props="defaultProps"
            v-show="!Textarea"
            :data="deviceDidList">
            </el-tree>
            <el-input type="textarea" v-show="Textarea" style="margin:0 auto" 
            v-model="TextareaValue" @change="GetTextareaValue" autosize
            spellcheck ="false"/>
          </div>
        </el-card>
      </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">{{$t('lang.taskDialog.cancel')}}</el-button>
        <el-button type="primary" @click="innerVisible=true" :disabled="disabled">{{$t('lang.taskDialog.Determine')}}</el-button>
      </span>
      <el-dialog
      width="40%" center
      title="确认创建任务"
      :visible.sync="innerVisible"
      append-to-body>
      <div>
        <div style="text-align:center">
        <p style="font-size:18px;font-weight:700;margin: 10px 0px;">选中设备列表</p>
        <p>1120ZR21806190001</p>
        <p>1120ZR21806190001</p>
        <p>1120ZR21806190001</p>
        <p>1120ZR21806190001</p>
        <p>1120ZR21806190001</p>
        <p>1120ZR21806190001</p>
        <p>1120ZR21806190001</p>
        <p>1120ZR21806190001</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false" size="mini">{{$t('lang.taskDialog.cancel')}}</el-button>
        <el-button type="primary" @click="addLevelUp" :disabled="disabled" size="mini">{{$t('lang.taskDialog.Determine')}}</el-button>
      </span>
    </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
// 任务组件  --接收两个参数，弹框标题 软件包or配置列表
import { addLevelUp,addConfig,findCanLevelUp } from '@/api/task'
import { mapActions,mapGetters } from 'vuex'
import json from './mock'
export default {
  props:{
    title:{
      type:String
    },
    packlist:{
      type:Array,
      default:()=>{
        return []
      }
    },
    radio:{
      type:String
    }
  },
  data() {
    return {
      centerDialogVisible: false,
      Grouping1:null,
      Grouping2:null,
      Grouping3:null,
      Groupinglist2:[],
      Groupinglist3:[],
      addtaskname:'',
      addtaskms:'',
      value:[],
      deviceslist:[],
      pack:null,
      //设备选中集合
      deviceDidList:[],
      deviceDid:[],
      //上传的文件信息
      uppack:null,
      //文件地址选项
      FirmwareList:[
        {value:0,label:'备份服务器'},
        {value:1,label:'默认服务器'}
      ],
      //文件地址选中值
      FirmwareValue:0,
      DeviceProps:{
        label: 'deviceSn',
        children: 'devices'
      },
      defaultProps:{
          label: 'deviceSn'
        },
      //按钮不可点击控制
      disabled:false,
      // 设备待选列表搜索
    filterValue:'',
    //文本域切换
    Textarea:false,
    TextareaValue:'',
    //创建任务最终确认框
    innerVisible:false
    }
  },
  methods:{
    ...mapActions(['getGroupList']),
    //显示弹出层
    showDialog(){
      this.centerDialogVisible=true
      //释放确定按钮
      this.disabled=false
      // 清空所有选择数据
      this.uppack=null
      this.pack=null
      this.addtaskname=''
      this.addtaskms=''
      this.value=[]
      this.Grouping1=null
      this.Grouping2=null
      this.Grouping3=null
      this.deviceDid=[]
      this.deviceDidList=[]
      this.Groupinglist2=[]
      this.Groupinglist3=[]
      this.Grouping2=null
      this.Grouping3=null
      this.deviceslist=[]
      setTimeout(()=>{
        this.getGroupList()
      },500)
    },
    //获取二级分组
    getGroupList2(){
      //每次选择一级分组清空二三级分组已经设备列表
      this.Groupinglist2=[]
      this.Groupinglist3=[]
      this.Grouping2=null
      this.Grouping3=null
      this.deviceslist=[]
      this.Grouplist.forEach(element => {
        if(element.group_id==this.Grouping1){
          this.Groupinglist2=element.groupList
          this.deviceslist=element.devices
        }
      });
    },
    //获取三级分组
    getGroupList3(){
      //每次选择二级级分组清空三级分组已经设备列表
      this.Groupinglist3=[]
      this.Grouping3=null
      this.deviceslist=[]
      this.Groupinglist2.forEach(element => {
        if(element.group_id==this.Grouping2){
          this.Groupinglist3=element.groupList
          this.deviceslist=element.devices
        }
      })
    },
    //获取三级分组下的设备
    getGroupList3devices(){
      this.Groupinglist3.forEach(element => {
        if(element.group_id==this.Grouping3){
          this.deviceslist=element.devices
        }
      })
    },
    //获取当前选中的软件包文件
    getpack(){
      this.packlist.forEach((val,index,arr)=>{
        if(val.spId==this.pack){
          this.uppack=val
        }
      })
    },
    //获取当前选中的配置文件
    getpackpz(){
      this.packlist.forEach((val,index,arr)=>{
        if(val.cfId==this.pack){
          this.uppack=val
        }
      })
    },
    //添加升级任务
    addLevelUp(){
      if(this.deviceDidList.length==0){
        this.$message({
          showClose: true,
          message: this.$t('lang.taskDialog.please'),
          type: 'warning'
        });
        return
      }
      else {
        this.deviceDidList.forEach((val,index)=>{
          //获取选中的设备
          this.deviceDid.push(val.deviceDid)
        })
      }
      // 文件未选择
      if(this.pack==null){
        this.$message({
          showClose: true,
          message: this.$t('lang.taskDialog.File_Upload_Upgrader'),
          type: 'warning'
        });
        return
      }
      //点击后确定按钮不可点击
      this.disabled=true
      // 批量升级任务
      if(this.title==this.$t('lang.upgrade.addDistributionPackages')){
      addLevelUp(this.addtaskname,this.addtaskms,this.deviceDid,this.uppack.spPath,
      this.uppack.spFileSize,this.uppack.spId,this.radio,this.FirmwareValue)
      .then((res)=>{
        if(res.data.code==0){
          this.$message({
          showClose: true,
          message: this.$t('lang.taskDialog.Dispatched'),
          type: 'success'
        })
        //添加完触发方法刷新列表
        this.$emit('getupgradelist')
        this.centerDialogVisible=!this.centerDialogVisible
        }
        else {
          this.$message({
          showClose: true,
          message: this.$t('lang.taskDialog.operation'),
          type: 'warning'
        });
        //释放确定按钮
        this.disabled=false
        }
      })
      }
      // 批量配置任务
      else if(this.title==this.$t('lang.firmware.configuration')){
        addConfig(this.addtaskname,this.addtaskms,this.deviceDid,this.uppack.cfPath,
        this.uppack.cfFileSize,this.uppack.cfId)
        .then((res)=>{
          if(res.data.code==0){
            this.$message({
          showClose: true,
          message: this.$t('lang.taskDialog.Dispatched'),
          type: 'success'
          })
          this.centerDialogVisible=!this.centerDialogVisible
          //添加完触发方法，刷新列表数据
          this.$emit('getupgradelist')
          }
          else {
            this.$message({
          showClose: true,
          message: this.$t('lang.taskDialog.operation'),
          type: 'warning'
        });
        //释放确定按钮
        this.disabled=false
          }
        })
      }
    },
    //获取分组下的设备集合
    FindCanLevelUp(GroupId){
      findCanLevelUp(GroupId)
      .then((res)=>{
        console.log(res.data.data)
        this.deviceslist=res.data.data.map((val,index)=>{
          val.deviceSn=val.deviceSoftwareVer
          return val
        })
      })
      // this.deviceslist=json.data.map((val,index)=>{
      //   val.deviceSn=val.deviceSoftwareVer
      //     return val
      // })
    },
    //tree复选框选中事件
    handleCheckChange() {
        //获取选中的设备
          this.deviceDidList=this.$refs.UpGradeTree.getCheckedNodes(true)
      },
      //设备待选列表搜索
    filterNode(value, data){
      console.log(data)
      if (!value) return true;
      return data.deviceSn.indexOf(value) !== -1;
    },
    //获取文本域内容
    GetTextareaValue(){
      this.TextareaValue.replace(/\s/ig,'')
      this.TextareaValue.split(/\n/g)
      console.log(this.TextareaValue)
    }
  },
  watch:{
    Grouping1:{
      handler(NewValue,OldValue){
        this.FindCanLevelUp(NewValue)
      }
    },
    Grouping2:{
      handler(NewValue,OldValue){
        this.FindCanLevelUp(NewValue)
      }
    },
    Grouping3:{
      handler(NewValue,OldValue){
        this.FindCanLevelUp(NewValue)
      }
    },
    filterValue(val){
      console.log(val)
      this.$refs.UpGradeTree.filter(val);
    }
  },
  mounted(){
    this.getGroupList()
    this.deviceslist=[]
  },
  computed:{
    ...mapGetters(['Grouplist'])
  }
};
</script>
<style scoped>
.dialog-con {
  width: 100%;
}
.dialog-con-center{
  text-align: center;
}
.adduserinput {
  display: inline-block;
  width: 50%;
  margin: 0.2rem;
}
.tetxp {
  display: inline-block;
  width: 2.7rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}
.packTitle{
  display: inline-block;
  width: 2.7rem;
  margin-top: 0.1rem;
  font-size: 14px;
  color: #888888;
  margin-bottom: 0.1rem;
  text-align: right;
}
.packText{
  color: #888888;
  font-size: 14px;
}
  .box-con{
    margin: 10px 0px;
    display: flex;
    justify-content: center;
  }
 .box-card {
    width: 48%;
    height: 30vh;
    overflow: scroll;
  }
  .box-card--tree{
    width: 100%;
  }
  .box-card--title{
    margin: 0.15rem;
    text-align: center;
    font-size: 15px;
    color: #888888;
  }
  .Bottom_Con{
    width: 90%;
    border: 1px solid #ebebeb;
    margin: 0 auto;
  }
  .Left_Con{
    width: 45%;
    margin-bottom: 10px;
    display: inline-block;
    border: 1px solid #ebebeb;
  }
  .Right_Con{
    width: 45%;
    margin-bottom: 10px;
    display: inline-block;
    border: 1px solid #ebebeb;
  }
  .SelectedColor{
    color: #409eff;
    font-size: 14px;
    cursor: pointer;
  }
</style>
